/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import { defineComponent, h } from 'vue';
import { gradientProps } from './props.js';
import '@babel/runtime/helpers/defineProperty';
import './utils/uid.js';
import './constant.js';

var Gradient = defineComponent({
  name: "SparklineGradient",
  inheritAttrs: false,
  props: gradientProps,
  render: function render() {
    var gradient = this.gradient,
        id = this.id;

    if (!gradient.length) {
      return null;
    }

    var len = gradient.length - 1 || 1;
    var stops = gradient.slice().reverse().map(function (c, i) {
      return h("stop", {
        offset: i / len,
        "stop-color": c,
        key: i
      });
    });
    return h("defs", [h("linearGradient", {
      id: id,
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1
    }, stops)]);
  }
});

export { Gradient as default };
//# sourceMappingURL=Gradient.js.map
